<template>
  <div class="home">
    <MyHeader title="gather" :showBack="false"></MyHeader>
    <div class="content">
      <div class="swiper-container" ref="cur">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img ref="bannerHeight" src="../../assets/gather/gather-home.jpg" />
          </div>
          <div class="swiper-slide">
            <!-- <div class="cover"></div> -->
            <img ref="bannerHeight" src="../../assets/gather/gather-market.png" />
          </div>
<!--          <div class="swiper-slide">-->
<!--            <div class="cover"></div>-->
<!--            <img ref="bannerHeight" src="../../assets/gather/gather-img.png" />-->
<!--          </div>-->
          <div class="swiper-slide">
            <img ref="bannerHeight" src="../../assets/gather/gather-member.png" />
          </div>
        </div>
      </div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <!-- <el-carousel type="card" :autoplay="false" arrow="always" :height="bannerHeight + 'px'">
        <el-carousel-item>
          <img ref="bannerHeight" src="../../assets/gather/gather-home.png" />
        </el-carousel-item>
        <el-carousel-item> <img src="../../assets/gather/gather-img.png" /> </el-carousel-item>
        <el-carousel-item> <img src="../../assets/gather/gather-img.png" /> </el-carousel-item>
      </el-carousel> -->
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/Header';
import { Loading } from 'element-ui';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'Gather',
  data() {
    return {
      bannerHeight: '',
    };
  },
  components: {
    MyHeader,
  },
  mounted() {
    let loading = Loading.service();
    setTimeout(() => {
      loading.close();
    }, 200);
    const that = this;
    let mySwiper = new Swiper(this.$refs.cur, {
      loop: true,
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      // spaceBetween: 100,
      coverflowEffect: {
        rotate: 0,
        stretch: 48,
        depth: 20,
        modifier: 13,
        // slideShadows: true,
      },
      // 如果需要分页器
      // pagination: {
      //   el: '.swiper-pagination',

      //   //点击小球的时候也切换图片
      //   clickable: true,
      // },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        click(e) {
          if (e.target.attributes.src.nodeValue.indexOf('/gather-home') > 0) {
            that.gotoHome('home');
          }
          if (e.target.attributes.src.nodeValue.indexOf('/gather-market') > 0) {
            that.gotoHome('market');
          }
          if (e.target.attributes.src.nodeValue.indexOf('/gather-member') > 0) {
            that.gotoHome('member');
          }
        },
      },
    });
  },
  methods: {
    gotoHome(route) {
      window.open('/#/' + route);
      // router.push('/home');
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1600px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 145%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.header {
  /*width: 3200px;*/
  width: 100%;
  height: 96px;
  background: url('~img/home/header-bg.png') no-repeat;
  background-size: 100% 100%;
  /*opacity: 0.71;*/
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -12px;
  position: relative;
  z-index: 99;

  span {
    width: 751px;
    height: 44px;
    background: url('~img/gather/gather-bg.png') no-repeat;
    background-size: 100% 100%;
    /*font-family: JLinXin;*/
    /*font-size: 46px;*/
    /*font-weight: 400;*/
    /*color: #f1ffff;*/
    /*line-height: 43px;*/

    /*background: linear-gradient(180deg, #83ffff 0%, #d9fafb 100%);*/
    /*-webkit-background-clip: text;*/
    /*-webkit-text-fill-color: transparent;*/
  }

  .home-admin {
    width: 50px;
    height: 50px;
    display: block;
    position: absolute;
    right: 191px;
    cursor: pointer;
    background: url('~img/home/header-user.png') no-repeat;
    background-size: 100% 100%;
  }
  .logout {
    width: 198px;
    height: 50px;
    background: url('~img/home/header-logout.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    span {
      font-size: 24px;
      line-height: 50px;
      font-weight: 400;
      color: #b5c4d0;
      background: none;
      &::before {
        content: '退出登录';
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
        font-weight: 400;
        background: linear-gradient(
          -72deg,
          rgba(129, 161, 186, 0.44) 0%,
          rgba(255, 255, 255, 0.44) 12.646484375%,
          rgba(137, 161, 181, 0.44) 30.95703125%,
          rgba(255, 255, 255, 0.44) 54.00390625%,
          rgba(141, 176, 204, 0.44) 79.833984375%,
          rgba(255, 255, 255, 0.44) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: absolute;
        top: 0;
      }
    }
    position: absolute;
    right: 14px;
    cursor: pointer;
  }
}

.content {
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100vh - 135px);
  z-index: 11;
  .swiper-container {
    padding: 320px 171px 144px 169px;
  }
  .swiper-slide {
    width: 1962px !important;
    height: 666px !important;
    background: #020202;
    border: 2px solid #53a4cc;
    box-shadow: 0px 19px 84px 0px #010101;
    border-radius: 32px;
    overflow: hidden;
    opacity: 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    // &.swiper-slide-active {
    //   width: 1962px !important;
    //   height: 666px !important;
    // }
    &.swiper-slide-active,
    &.swiper-slide-next,
    &.swiper-slide-prev {
      opacity: 1;
    }

    .cover {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      top: 0;
      left: 0;
      &::before {
        width: 444px;
        height: 86px;
        display: block;
        content: ' ';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url('~img/gather/gather-cover.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 70px;
    height: 70px;
    background: url(../../assets/gather/gather-btn.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      width: 13px;
      height: 19px;
      display: block;
      content: ' ';
      background: url(../../assets/gather/gather-i1.png) no-repeat;
      background-size: 100% 100%;
      opacity: 0.4;
    }
    &::after {
      width: 9px;
      height: 15px;
      display: block;
      content: ' ';
      background: url(../../assets/gather/gather-i2.png) no-repeat;
      background-size: 100% 100%;
      margin-left: 1px;
      margin-right: 5px;
      opacity: 0.4;
    }
    &:hover {
      &::after,
      &::before {
        opacity: 1;
      }
    }
  }
  .swiper-button-prev {
    left: 96px;
  }
  .swiper-button-next {
    right: 96px;
    &::after,
    &::before {
      transform: rotate(180deg);
    }
    &::before {
      width: 9px;
      height: 15px;
      display: block;
      content: ' ';
      background: url(../../assets/gather/gather-i2.png) no-repeat;
      background-size: 100% 100%;
      margin-left: 5px;
      margin-right: 1px;
    }
    &::after {
      width: 13px;
      height: 19px;
      display: block;
      content: ' ';
      background: url(../../assets/gather/gather-i1.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  //.el-carousel {
  //  width: 100%;
  //  /deep/.el-carousel__container {
  //    width: 100%;
  //  }
  //  .el-carousel__item {
  //    width: 1572px;
  //    height: 533px;
  //    background: #020202;
  //    border: 2px solid #53a4cc;
  //    box-shadow: 0px 19px 84px 0px #010101;
  //    border-radius: 32px;
  //    // margin-left: calc(25% - 786px);
  //    &.is-active {
  //      width: 1962px;
  //      height: 666px;
  //      margin-left: calc(25% - 981px);
  //      // & + .el-carousel__item {
  //      //   margin-left: calc(25% - 850px);
  //      // }
  //    }
  //    iframe,
  //    img {
  //      width: 100%;
  //      height: 100%;
  //      border: none;
  //    }
  //  }
  //}
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

// .loading {
//   width: 100%;
//   height: 100%;
//   background: rgba(0, 0, 0, 0.5);
//   backdrop-filter: blur(20px);
//   /*filter: blur(10px);*/
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 9;
// }
</style>
